import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { InventoryService } from 'src/app/services/inventory.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Component({
  selector: "app-remove-tags",
  templateUrl: "./remove-tags.component.html",
  styleUrls: ["./remove-tags.component.scss"],
})

export class RemoveTagsComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  spin:boolean = false;
  skuTags:any[] = [];
  productTags:any[] = [];
  loading:boolean=false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<RemoveTagsComponent>,
    private inventoryService:InventoryService,
    private snackBar:MatSnackBar
  ){}
  
  ngOnInit(): void {
    this.loading = true;
    this.getTags(); 
  }

  getTags() {
    let endpoint = this.inventoryService.getSkuTags();
    if(this.data.page !== 'shipyard' && this.data.page!=='replenish'){
      endpoint= this.inventoryService.getProductTags();
    }
    endpoint.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {        
        this.skuTags = res;
      },
      error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err?.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
      },
      complete:()=> {
        this.loading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  action(event) {
   if(event=='Remove'){
    this.remove();
    }else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  removeSku(index){
    this.skuTags.splice(index,1);
  }

  removeTag(tagId,index){
    this.skuTags[index].tagsDto.splice(tagId,1);
  }

  remove(){
    this.spin = true;
    let payload:any={}, endpoint,removeIds: any[] = [];
    
    this.skuTags.forEach((sku,i)=>{
      let selectedItem:any =  {
        tags:[]
      };
      if(this.data.page == 'shipyard' || this.data.page == 'replenish'){
        selectedItem.accountSkuId = sku.accountSkuId;
      } else{
        selectedItem.itemId = sku.id;
      }
      sku.tagsDto.map((skuItem,i)=>{
        selectedItem.tags.push(skuItem.tagId)
     });
     removeIds.push(selectedItem);
   }); 
   if(this.data.page == 'shipyard' || this.data.page == 'replenish'){
     payload.removeSkuList= removeIds;
     endpoint=this.inventoryService.removeSkuTags(payload);
   } else {
     payload.removeItemList= removeIds;
     endpoint=this.inventoryService.removeProductTags(payload);
   }
    endpoint.pipe(takeUntil(this.destroy$)).subscribe({
      next:(res)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Sku Tags has been removed successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
        );
        this.dialogRef.close(true);
      },
      error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      },
      complete:()=>{
        this.spin = false;
      }
    })
  }
}
